module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('head-nav'), _vm._v(" "), _c('div', {
    staticClass: "left-fixed-right-auto"
  }, [_c('left-menu'), _vm._v(" "), _c('div', {
    staticClass: "content_page",
    style: ({
      'margin-left': _vm.$store.state.menu.sidebar.width,
      'width': _vm.$store.state.page.win_content.width + 'px',
      'height': _vm.$store.state.page.win_content.height + 'px'
    })
  }, [_c('div', {
    staticClass: "content"
  }, [_c('bread', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleId == 1),
      expression: "roleId==1"
    }]
  }), _vm._v(" "), _c('router-view')], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02f536d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/home.vue
// module id = 1218
// module chunks = 2